var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8 136.494C86.6 149.394 85.4 162.694 85.4 176.294C85.4 189.894 86.6 203.294 88.8 216.094L256 228.294L423.2 216.194C425.4 203.294 426.6 189.994 426.6 176.394C426.6 162.794 425.4 149.394 423.2 136.594",
    fill: "#0072C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.2 218.994H88.8C104.6 288.794 173.5 341.294 256 341.294C338.5 341.294 407.4 288.794 423.2 218.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.9 136.494H146.1L191 115.394L167.1 71.8941L215.9 81.2941L222 31.9941L256 68.1941L290 31.9941L296.1 81.2941L344.9 71.8941L321 115.394L365.9 136.494Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 341.994L0 -0.00585938V341.994H256.5Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 341.994V-0.00585938L256 341.994H513Z",
    fill: "#CE1126"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/AG.797553e4a075a33b2bdd87219c97924c.svg";
export { ForwardRef as ReactComponent };